import { default as aboutLvLfQEDUA8Meta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventseZEEbbrCVEMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93WLXzXZvE6LMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleg5euBMYILaMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45products56Ru8sxtCDMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93iUNfc9DqMJMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewV8q3hoKxd3Meta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexOVSSsxZAcrMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93ii6gdVNGBjMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as index2c6FaNNOfcMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93lmtwInP3sYMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexsNvO760jxyMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsrj17gXYOKkMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsuBeuyyLmIbMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsLJMwEMQcXZMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93JMO1YsYnHtMeta } from "/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexDjPO1DyfChMeta } from "/tmp/build_e9255189/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirm5JUSdZHxIiMeta } from "/tmp/build_e9255189/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmt0LQpyHCl5Meta } from "/tmp/build_e9255189/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarTocogAf51AMeta } from "/tmp/build_e9255189/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatSHbKNT9uXWMeta } from "/tmp/build_e9255189/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutgdDgJpHunWMeta } from "/tmp/build_e9255189/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedZE5zCKhQQKMeta } from "/tmp/build_e9255189/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersPcIygbfXA7Meta } from "/tmp/build_e9255189/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93DT7C85pU6ZMeta } from "/tmp/build_e9255189/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editgqlNllHwmAMeta } from "/tmp/build_e9255189/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_930N3s3b7KujMeta } from "/tmp/build_e9255189/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communitykrqTgJ8C5YMeta } from "/tmp/build_e9255189/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93tQJJpILQIdMeta } from "/tmp/build_e9255189/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93W8nlgPKIkeMeta } from "/tmp/build_e9255189/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardqEpoik2beLMeta } from "/tmp/build_e9255189/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexkQlyIgbVV1Meta } from "/tmp/build_e9255189/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutpe31rMKKnoMeta } from "/tmp/build_e9255189/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productzO964toQjRMeta } from "/tmp/build_e9255189/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsVwt7V4HFCbMeta } from "/tmp/build_e9255189/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93VCjnXgDfsvMeta } from "/tmp/build_e9255189/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexPXxNgHYqyRMeta } from "/tmp/build_e9255189/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93tAyyl9Ns6GMeta } from "/tmp/build_e9255189/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93Mw8biRmC6FMeta } from "/tmp/build_e9255189/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexMlMmzHhnLQMeta } from "/tmp/build_e9255189/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93oOAipJNRMTMeta } from "/tmp/build_e9255189/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as join5pFoFtvYxqMeta } from "/tmp/build_e9255189/pages/[studio_url]/join.vue?macro=true";
import { default as loginG4XuNA7ICMMeta } from "/tmp/build_e9255189/pages/[studio_url]/login.vue?macro=true";
import { default as logoutdLwnznnpHEMeta } from "/tmp/build_e9255189/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93N5iOjveVJHMeta } from "/tmp/build_e9255189/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93RPLpDRnfNdMeta } from "/tmp/build_e9255189/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93IERIkmJGsPMeta } from "/tmp/build_e9255189/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesulmKVA1DNwMeta } from "/tmp/build_e9255189/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studios0ccCr12hwNMeta } from "/tmp/build_e9255189/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optin1LSy7HUNLlMeta } from "/tmp/build_e9255189/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93zwAzXbUm9nMeta } from "/tmp/build_e9255189/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexPXFXqbGsmFMeta } from "/tmp/build_e9255189/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexJVvmzAwQtwMeta } from "/tmp/build_e9255189/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as about2rN2niefcwMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45content7fRANsrMe3Meta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsEhvHoY2AfBMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93QNtdPo5LK4Meta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplewobl6SeF9sMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsbopUDrv2XjMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93XiOwWEnwSpMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewdoI9VPuzKiMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexpPxFhTGXNlMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93Ft2B6YlrlwMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexwisLf3Iq1mMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93b6fYJA4iS9Meta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexTpz4qz63hBMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionswKb5c5rKm8Meta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsgydIxIoXRsMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsJ7I2QDFnuPMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93D3UgTin6otMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as index4BRGMB1TfxMeta } from "/tmp/build_e9255189/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexUWiQ8J1n0MMeta } from "/tmp/build_e9255189/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesA2i7yMBOdVMeta } from "/tmp/build_e9255189/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptions3GVDG0hwTAMeta } from "/tmp/build_e9255189/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93M9wQhSDrRmMeta } from "/tmp/build_e9255189/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_930iLfWQChiVMeta } from "/tmp/build_e9255189/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetEdqq0mXytgMeta } from "/tmp/build_e9255189/pages/[studio_url]/reset.vue?macro=true";
import { default as shopq3NUbIqmTiMeta } from "/tmp/build_e9255189/pages/[studio_url]/shop.vue?macro=true";
import { default as signupI34ONdo3yuMeta } from "/tmp/build_e9255189/pages/[studio_url]/signup.vue?macro=true";
import { default as livemQvrtT8H2SMeta } from "/tmp/build_e9255189/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsXXBc2FcpYvMeta } from "/tmp/build_e9255189/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93b5mCihLXoIMeta } from "/tmp/build_e9255189/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compact2UHqeNqR4LMeta } from "/tmp/build_e9255189/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullhXH7FbqZxsMeta } from "/tmp/build_e9255189/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93JMO1YsYnHtMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93JMO1YsYnHtMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93JMO1YsYnHtMeta || {},
    alias: _91product_id_93JMO1YsYnHtMeta?.alias || [],
    redirect: _91product_id_93JMO1YsYnHtMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutLvLfQEDUA8Meta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutLvLfQEDUA8Meta?.path ?? "about",
    meta: aboutLvLfQEDUA8Meta || {},
    alias: aboutLvLfQEDUA8Meta?.alias || [],
    redirect: aboutLvLfQEDUA8Meta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventseZEEbbrCVEMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventseZEEbbrCVEMeta?.path ?? "events",
    meta: eventseZEEbbrCVEMeta || {},
    alias: eventseZEEbbrCVEMeta?.alias || [],
    redirect: eventseZEEbbrCVEMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93WLXzXZvE6LMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93WLXzXZvE6LMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93WLXzXZvE6LMeta || {},
    alias: _91media_id_93WLXzXZvE6LMeta?.alias || [],
    redirect: _91media_id_93WLXzXZvE6LMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleg5euBMYILaMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleg5euBMYILaMeta?.path ?? "free-sample",
    meta: free_45sampleg5euBMYILaMeta || {},
    alias: free_45sampleg5euBMYILaMeta?.alias || [],
    redirect: free_45sampleg5euBMYILaMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45products56Ru8sxtCDMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45products56Ru8sxtCDMeta?.path ?? "included-products",
    meta: included_45products56Ru8sxtCDMeta || {},
    alias: included_45products56Ru8sxtCDMeta?.alias || [],
    redirect: included_45products56Ru8sxtCDMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93iUNfc9DqMJMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93iUNfc9DqMJMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93iUNfc9DqMJMeta || {},
    alias: _91media_id_93iUNfc9DqMJMeta?.alias || [],
    redirect: _91media_id_93iUNfc9DqMJMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewV8q3hoKxd3Meta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewV8q3hoKxd3Meta?.path ?? "lessons/:lesson_id()/view",
    meta: viewV8q3hoKxd3Meta || {},
    alias: viewV8q3hoKxd3Meta?.alias || [],
    redirect: viewV8q3hoKxd3Meta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexOVSSsxZAcrMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexOVSSsxZAcrMeta?.path ?? "lessons",
    meta: indexOVSSsxZAcrMeta || {},
    alias: indexOVSSsxZAcrMeta?.alias || [],
    redirect: indexOVSSsxZAcrMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ii6gdVNGBjMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93ii6gdVNGBjMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93ii6gdVNGBjMeta || {},
    alias: _91media_id_93ii6gdVNGBjMeta?.alias || [],
    redirect: _91media_id_93ii6gdVNGBjMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index2c6FaNNOfcMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: index2c6FaNNOfcMeta?.path ?? "playlists/:playlist_id()",
    meta: index2c6FaNNOfcMeta || {},
    alias: index2c6FaNNOfcMeta?.alias || [],
    redirect: index2c6FaNNOfcMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93lmtwInP3sYMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93lmtwInP3sYMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93lmtwInP3sYMeta || {},
    alias: _91media_id_93lmtwInP3sYMeta?.alias || [],
    redirect: _91media_id_93lmtwInP3sYMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexsNvO760jxyMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexsNvO760jxyMeta?.path ?? "playlists",
    meta: indexsNvO760jxyMeta || {},
    alias: indexsNvO760jxyMeta?.alias || [],
    redirect: indexsNvO760jxyMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsrj17gXYOKkMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsrj17gXYOKkMeta?.path ?? "private-sessions",
    meta: private_45sessionsrj17gXYOKkMeta || {},
    alias: private_45sessionsrj17gXYOKkMeta?.alias || [],
    redirect: private_45sessionsrj17gXYOKkMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsuBeuyyLmIbMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsuBeuyyLmIbMeta?.path ?? "recordings",
    meta: recordingsuBeuyyLmIbMeta || {},
    alias: recordingsuBeuyyLmIbMeta?.alias || [],
    redirect: recordingsuBeuyyLmIbMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsLJMwEMQcXZMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsLJMwEMQcXZMeta?.path ?? "reviews",
    meta: reviewsLJMwEMQcXZMeta || {},
    alias: reviewsLJMwEMQcXZMeta?.alias || [],
    redirect: reviewsLJMwEMQcXZMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexDjPO1DyfChMeta?.name ?? "buy-product-product_id",
    path: indexDjPO1DyfChMeta?.path ?? "/buy/product/:product_id()",
    meta: indexDjPO1DyfChMeta || {},
    alias: indexDjPO1DyfChMeta?.alias || [],
    redirect: indexDjPO1DyfChMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirm5JUSdZHxIiMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirm5JUSdZHxIiMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirm5JUSdZHxIiMeta || {},
    alias: confirm5JUSdZHxIiMeta?.alias || [],
    redirect: confirm5JUSdZHxIiMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmt0LQpyHCl5Meta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmt0LQpyHCl5Meta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmt0LQpyHCl5Meta || {},
    alias: confirmt0LQpyHCl5Meta?.alias || [],
    redirect: confirmt0LQpyHCl5Meta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarTocogAf51AMeta?.name ?? "calendar",
    path: calendarTocogAf51AMeta?.path ?? "/calendar",
    meta: calendarTocogAf51AMeta || {},
    alias: calendarTocogAf51AMeta?.alias || [],
    redirect: calendarTocogAf51AMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatSHbKNT9uXWMeta?.name ?? "chat",
    path: chatSHbKNT9uXWMeta?.path ?? "/chat",
    meta: chatSHbKNT9uXWMeta || {},
    alias: chatSHbKNT9uXWMeta?.alias || [],
    redirect: chatSHbKNT9uXWMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93DT7C85pU6ZMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93DT7C85pU6ZMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93DT7C85pU6ZMeta || {},
    alias: _91group_id_93DT7C85pU6ZMeta?.alias || [],
    redirect: _91group_id_93DT7C85pU6ZMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutgdDgJpHunWMeta?.name ?? "community-groups-group_id-about",
    path: aboutgdDgJpHunWMeta?.path ?? "about",
    meta: aboutgdDgJpHunWMeta || {},
    alias: aboutgdDgJpHunWMeta?.alias || [],
    redirect: aboutgdDgJpHunWMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedZE5zCKhQQKMeta?.name ?? "community-groups-group_id-feed",
    path: feedZE5zCKhQQKMeta?.path ?? "feed",
    meta: feedZE5zCKhQQKMeta || {},
    alias: feedZE5zCKhQQKMeta?.alias || [],
    redirect: feedZE5zCKhQQKMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersPcIygbfXA7Meta?.name ?? "community-groups-group_id-members",
    path: membersPcIygbfXA7Meta?.path ?? "members",
    meta: membersPcIygbfXA7Meta || {},
    alias: membersPcIygbfXA7Meta?.alias || [],
    redirect: membersPcIygbfXA7Meta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editgqlNllHwmAMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editgqlNllHwmAMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editgqlNllHwmAMeta || {},
    alias: community_45profile_45editgqlNllHwmAMeta?.alias || [],
    redirect: community_45profile_45editgqlNllHwmAMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_930N3s3b7KujMeta?.name ?? "community-profile-id",
    path: _91id_930N3s3b7KujMeta?.path ?? "/community-profile/:id()",
    meta: _91id_930N3s3b7KujMeta || {},
    alias: _91id_930N3s3b7KujMeta?.alias || [],
    redirect: _91id_930N3s3b7KujMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communitykrqTgJ8C5YMeta?.name ?? "community",
    path: communitykrqTgJ8C5YMeta?.path ?? "/community",
    meta: communitykrqTgJ8C5YMeta || {},
    alias: communitykrqTgJ8C5YMeta?.alias || [],
    redirect: communitykrqTgJ8C5YMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93tQJJpILQIdMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93tQJJpILQIdMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93tQJJpILQIdMeta || {},
    alias: _91uuid_93tQJJpILQIdMeta?.alias || [],
    redirect: _91uuid_93tQJJpILQIdMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93W8nlgPKIkeMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93W8nlgPKIkeMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93W8nlgPKIkeMeta || {},
    alias: _91unique_id_93W8nlgPKIkeMeta?.alias || [],
    redirect: _91unique_id_93W8nlgPKIkeMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardqEpoik2beLMeta?.name ?? "dashboard",
    path: dashboardqEpoik2beLMeta?.path ?? "/dashboard",
    meta: dashboardqEpoik2beLMeta || {},
    alias: dashboardqEpoik2beLMeta?.alias || [],
    redirect: dashboardqEpoik2beLMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexkQlyIgbVV1Meta?.name ?? "event-details-event_id",
    path: indexkQlyIgbVV1Meta?.path ?? "/event/details/:event_id()",
    meta: indexkQlyIgbVV1Meta || {},
    alias: indexkQlyIgbVV1Meta?.alias || [],
    redirect: indexkQlyIgbVV1Meta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutpe31rMKKnoMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutpe31rMKKnoMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutpe31rMKKnoMeta || {},
    alias: checkoutpe31rMKKnoMeta?.alias || [],
    redirect: checkoutpe31rMKKnoMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productzO964toQjRMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productzO964toQjRMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productzO964toQjRMeta || {},
    alias: select_45productzO964toQjRMeta?.alias || [],
    redirect: select_45productzO964toQjRMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsVwt7V4HFCbMeta?.name ?? "events",
    path: eventsVwt7V4HFCbMeta?.path ?? "/events",
    meta: eventsVwt7V4HFCbMeta || {},
    alias: eventsVwt7V4HFCbMeta?.alias || [],
    redirect: eventsVwt7V4HFCbMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93VCjnXgDfsvMeta?.name ?? "gifts-uuid",
    path: _91uuid_93VCjnXgDfsvMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93VCjnXgDfsvMeta || {},
    alias: _91uuid_93VCjnXgDfsvMeta?.alias || [],
    redirect: _91uuid_93VCjnXgDfsvMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexPXxNgHYqyRMeta?.name ?? "gifts",
    path: indexPXxNgHYqyRMeta?.path ?? "/gifts",
    meta: indexPXxNgHYqyRMeta || {},
    alias: indexPXxNgHYqyRMeta?.alias || [],
    redirect: indexPXxNgHYqyRMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93tAyyl9Ns6GMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93tAyyl9Ns6GMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93tAyyl9Ns6GMeta || {},
    alias: _91invitation_id_93tAyyl9Ns6GMeta?.alias || [],
    redirect: _91invitation_id_93tAyyl9Ns6GMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93Mw8biRmC6FMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93Mw8biRmC6FMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93Mw8biRmC6FMeta || {},
    alias: _91product_id_93Mw8biRmC6FMeta?.alias || [],
    redirect: _91product_id_93Mw8biRmC6FMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexMlMmzHhnLQMeta?.name ?? "index",
    path: indexMlMmzHhnLQMeta?.path ?? "/",
    meta: indexMlMmzHhnLQMeta || {},
    alias: indexMlMmzHhnLQMeta?.alias || [],
    redirect: indexMlMmzHhnLQMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93oOAipJNRMTMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93oOAipJNRMTMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93oOAipJNRMTMeta || {},
    alias: _91invitation_unique_id_93oOAipJNRMTMeta?.alias || [],
    redirect: _91invitation_unique_id_93oOAipJNRMTMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: join5pFoFtvYxqMeta?.name ?? "join",
    path: join5pFoFtvYxqMeta?.path ?? "/join",
    meta: join5pFoFtvYxqMeta || {},
    alias: join5pFoFtvYxqMeta?.alias || [],
    redirect: join5pFoFtvYxqMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginG4XuNA7ICMMeta?.name ?? "login",
    path: loginG4XuNA7ICMMeta?.path ?? "/login",
    meta: loginG4XuNA7ICMMeta || {},
    alias: loginG4XuNA7ICMMeta?.alias || [],
    redirect: loginG4XuNA7ICMMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutdLwnznnpHEMeta?.name ?? "logout",
    path: logoutdLwnznnpHEMeta?.path ?? "/logout",
    meta: logoutdLwnznnpHEMeta || {},
    alias: logoutdLwnznnpHEMeta?.alias || [],
    redirect: logoutdLwnznnpHEMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93N5iOjveVJHMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93N5iOjveVJHMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93N5iOjveVJHMeta || {},
    alias: _91meeting_type_slug_93N5iOjveVJHMeta?.alias || [],
    redirect: _91meeting_type_slug_93N5iOjveVJHMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93RPLpDRnfNdMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93RPLpDRnfNdMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93RPLpDRnfNdMeta || {},
    alias: _91meeting_unique_id_93RPLpDRnfNdMeta?.alias || [],
    redirect: _91meeting_unique_id_93RPLpDRnfNdMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93IERIkmJGsPMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93IERIkmJGsPMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93IERIkmJGsPMeta || {},
    alias: _91meeting_unique_id_93IERIkmJGsPMeta?.alias || [],
    redirect: _91meeting_unique_id_93IERIkmJGsPMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesulmKVA1DNwMeta?.name ?? "my-favorites",
    path: my_45favoritesulmKVA1DNwMeta?.path ?? "/my-favorites",
    meta: my_45favoritesulmKVA1DNwMeta || {},
    alias: my_45favoritesulmKVA1DNwMeta?.alias || [],
    redirect: my_45favoritesulmKVA1DNwMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studios0ccCr12hwNMeta?.name ?? "my-studios",
    path: my_45studios0ccCr12hwNMeta?.path ?? "/my-studios",
    meta: my_45studios0ccCr12hwNMeta || {},
    alias: my_45studios0ccCr12hwNMeta?.alias || [],
    redirect: my_45studios0ccCr12hwNMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optin1LSy7HUNLlMeta?.name ?? "optin",
    path: optin1LSy7HUNLlMeta?.path ?? "/optin",
    meta: optin1LSy7HUNLlMeta || {},
    alias: optin1LSy7HUNLlMeta?.alias || [],
    redirect: optin1LSy7HUNLlMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93zwAzXbUm9nMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93zwAzXbUm9nMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93zwAzXbUm9nMeta || {},
    alias: _91episode_id_93zwAzXbUm9nMeta?.alias || [],
    redirect: _91episode_id_93zwAzXbUm9nMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexPXFXqbGsmFMeta?.name ?? "podcasts-podcast_id",
    path: indexPXFXqbGsmFMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexPXFXqbGsmFMeta || {},
    alias: indexPXFXqbGsmFMeta?.alias || [],
    redirect: indexPXFXqbGsmFMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexJVvmzAwQtwMeta?.name ?? "podcasts",
    path: indexJVvmzAwQtwMeta?.path ?? "/podcasts",
    meta: indexJVvmzAwQtwMeta || {},
    alias: indexJVvmzAwQtwMeta?.alias || [],
    redirect: indexJVvmzAwQtwMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93D3UgTin6otMeta?.name ?? "product-product_id",
    path: _91product_id_93D3UgTin6otMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93D3UgTin6otMeta || {},
    alias: _91product_id_93D3UgTin6otMeta?.alias || [],
    redirect: _91product_id_93D3UgTin6otMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: about2rN2niefcwMeta?.name ?? "product-product_id-about",
    path: about2rN2niefcwMeta?.path ?? "about",
    meta: about2rN2niefcwMeta || {},
    alias: about2rN2niefcwMeta?.alias || [],
    redirect: about2rN2niefcwMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45content7fRANsrMe3Meta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45content7fRANsrMe3Meta?.path ?? "digital-download-content",
    meta: digital_45download_45content7fRANsrMe3Meta || {},
    alias: digital_45download_45content7fRANsrMe3Meta?.alias || [],
    redirect: digital_45download_45content7fRANsrMe3Meta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsEhvHoY2AfBMeta?.name ?? "product-product_id-events",
    path: eventsEhvHoY2AfBMeta?.path ?? "events",
    meta: eventsEhvHoY2AfBMeta || {},
    alias: eventsEhvHoY2AfBMeta?.alias || [],
    redirect: eventsEhvHoY2AfBMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93QNtdPo5LK4Meta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93QNtdPo5LK4Meta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93QNtdPo5LK4Meta || {},
    alias: _91media_id_93QNtdPo5LK4Meta?.alias || [],
    redirect: _91media_id_93QNtdPo5LK4Meta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplewobl6SeF9sMeta?.name ?? "product-product_id-free-sample",
    path: free_45samplewobl6SeF9sMeta?.path ?? "free-sample",
    meta: free_45samplewobl6SeF9sMeta || {},
    alias: free_45samplewobl6SeF9sMeta?.alias || [],
    redirect: free_45samplewobl6SeF9sMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsbopUDrv2XjMeta?.name ?? "product-product_id-included-products",
    path: included_45productsbopUDrv2XjMeta?.path ?? "included-products",
    meta: included_45productsbopUDrv2XjMeta || {},
    alias: included_45productsbopUDrv2XjMeta?.alias || [],
    redirect: included_45productsbopUDrv2XjMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93XiOwWEnwSpMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93XiOwWEnwSpMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93XiOwWEnwSpMeta || {},
    alias: _91media_id_93XiOwWEnwSpMeta?.alias || [],
    redirect: _91media_id_93XiOwWEnwSpMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewdoI9VPuzKiMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewdoI9VPuzKiMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewdoI9VPuzKiMeta || {},
    alias: viewdoI9VPuzKiMeta?.alias || [],
    redirect: viewdoI9VPuzKiMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexpPxFhTGXNlMeta?.name ?? "product-product_id-lessons",
    path: indexpPxFhTGXNlMeta?.path ?? "lessons",
    meta: indexpPxFhTGXNlMeta || {},
    alias: indexpPxFhTGXNlMeta?.alias || [],
    redirect: indexpPxFhTGXNlMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93Ft2B6YlrlwMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93Ft2B6YlrlwMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93Ft2B6YlrlwMeta || {},
    alias: _91media_id_93Ft2B6YlrlwMeta?.alias || [],
    redirect: _91media_id_93Ft2B6YlrlwMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexwisLf3Iq1mMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexwisLf3Iq1mMeta?.path ?? "playlists/:playlist_id()",
    meta: indexwisLf3Iq1mMeta || {},
    alias: indexwisLf3Iq1mMeta?.alias || [],
    redirect: indexwisLf3Iq1mMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93b6fYJA4iS9Meta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93b6fYJA4iS9Meta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93b6fYJA4iS9Meta || {},
    alias: _91media_id_93b6fYJA4iS9Meta?.alias || [],
    redirect: _91media_id_93b6fYJA4iS9Meta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexTpz4qz63hBMeta?.name ?? "product-product_id-playlists",
    path: indexTpz4qz63hBMeta?.path ?? "playlists",
    meta: indexTpz4qz63hBMeta || {},
    alias: indexTpz4qz63hBMeta?.alias || [],
    redirect: indexTpz4qz63hBMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionswKb5c5rKm8Meta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionswKb5c5rKm8Meta?.path ?? "private-sessions",
    meta: private_45sessionswKb5c5rKm8Meta || {},
    alias: private_45sessionswKb5c5rKm8Meta?.alias || [],
    redirect: private_45sessionswKb5c5rKm8Meta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsgydIxIoXRsMeta?.name ?? "product-product_id-recordings",
    path: recordingsgydIxIoXRsMeta?.path ?? "recordings",
    meta: recordingsgydIxIoXRsMeta || {},
    alias: recordingsgydIxIoXRsMeta?.alias || [],
    redirect: recordingsgydIxIoXRsMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsJ7I2QDFnuPMeta?.name ?? "product-product_id-reviews",
    path: reviewsJ7I2QDFnuPMeta?.path ?? "reviews",
    meta: reviewsJ7I2QDFnuPMeta || {},
    alias: reviewsJ7I2QDFnuPMeta?.alias || [],
    redirect: reviewsJ7I2QDFnuPMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index4BRGMB1TfxMeta?.name ?? "product",
    path: index4BRGMB1TfxMeta?.path ?? "/product",
    meta: index4BRGMB1TfxMeta || {},
    alias: index4BRGMB1TfxMeta?.alias || [],
    redirect: index4BRGMB1TfxMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexUWiQ8J1n0MMeta?.name ?? "profile",
    path: indexUWiQ8J1n0MMeta?.path ?? "/profile",
    meta: indexUWiQ8J1n0MMeta || {},
    alias: indexUWiQ8J1n0MMeta?.alias || [],
    redirect: indexUWiQ8J1n0MMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesA2i7yMBOdVMeta?.name ?? "profile-purchases",
    path: purchasesA2i7yMBOdVMeta?.path ?? "/profile/purchases",
    meta: purchasesA2i7yMBOdVMeta || {},
    alias: purchasesA2i7yMBOdVMeta?.alias || [],
    redirect: purchasesA2i7yMBOdVMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptions3GVDG0hwTAMeta?.name ?? "profile-redemptions",
    path: redemptions3GVDG0hwTAMeta?.path ?? "/profile/redemptions",
    meta: redemptions3GVDG0hwTAMeta || {},
    alias: redemptions3GVDG0hwTAMeta?.alias || [],
    redirect: redemptions3GVDG0hwTAMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93M9wQhSDrRmMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93M9wQhSDrRmMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93M9wQhSDrRmMeta || {},
    alias: _91quiz_id_93M9wQhSDrRmMeta?.alias || [],
    redirect: _91quiz_id_93M9wQhSDrRmMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_930iLfWQChiVMeta?.name ?? "reset-password-uid-token",
    path: _91token_930iLfWQChiVMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_930iLfWQChiVMeta || {},
    alias: _91token_930iLfWQChiVMeta?.alias || [],
    redirect: _91token_930iLfWQChiVMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetEdqq0mXytgMeta?.name ?? "reset",
    path: resetEdqq0mXytgMeta?.path ?? "/reset",
    meta: resetEdqq0mXytgMeta || {},
    alias: resetEdqq0mXytgMeta?.alias || [],
    redirect: resetEdqq0mXytgMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopq3NUbIqmTiMeta?.name ?? "shop",
    path: shopq3NUbIqmTiMeta?.path ?? "/shop",
    meta: shopq3NUbIqmTiMeta || {},
    alias: shopq3NUbIqmTiMeta?.alias || [],
    redirect: shopq3NUbIqmTiMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupI34ONdo3yuMeta?.name ?? "signup",
    path: signupI34ONdo3yuMeta?.path ?? "/signup",
    meta: signupI34ONdo3yuMeta || {},
    alias: signupI34ONdo3yuMeta?.alias || [],
    redirect: signupI34ONdo3yuMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: livemQvrtT8H2SMeta?.name ?? "streaming-event_id-live",
    path: livemQvrtT8H2SMeta?.path ?? "/streaming/:event_id()/live",
    meta: livemQvrtT8H2SMeta || {},
    alias: livemQvrtT8H2SMeta?.alias || [],
    redirect: livemQvrtT8H2SMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsXXBc2FcpYvMeta?.name ?? "tips",
    path: tipsXXBc2FcpYvMeta?.path ?? "/tips",
    meta: tipsXXBc2FcpYvMeta || {},
    alias: tipsXXBc2FcpYvMeta?.alias || [],
    redirect: tipsXXBc2FcpYvMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93b5mCihLXoIMeta?.name ?? "waiver-uuid",
    path: _91uuid_93b5mCihLXoIMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93b5mCihLXoIMeta || {},
    alias: _91uuid_93b5mCihLXoIMeta?.alias || [],
    redirect: _91uuid_93b5mCihLXoIMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compact2UHqeNqR4LMeta?.name ?? "widgets-calendars-compact",
    path: compact2UHqeNqR4LMeta?.path ?? "/widgets/calendars/compact",
    meta: compact2UHqeNqR4LMeta || {},
    alias: compact2UHqeNqR4LMeta?.alias || [],
    redirect: compact2UHqeNqR4LMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullhXH7FbqZxsMeta?.name ?? "widgets-calendars-full",
    path: fullhXH7FbqZxsMeta?.path ?? "/widgets/calendars/full",
    meta: fullhXH7FbqZxsMeta || {},
    alias: fullhXH7FbqZxsMeta?.alias || [],
    redirect: fullhXH7FbqZxsMeta?.redirect,
    component: () => import("/tmp/build_e9255189/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]